import type * as api from '@gitbook/api-client';

export function extractCollectionNames(
    allContent: api.OrganizationAllContent
): Map<string, string> {
    const collectionNameMap = new Map<string, string>();

    const iterate = (
        items: ReadonlyArray<api.OrganizationAllCollection | api.OrganizationAllSpace>
    ) => {
        for (const item of items) {
            if ('collection' in item) {
                collectionNameMap.set(item.collection.id, item.collection.title);
                iterate(item.content);
            }
        }
    };

    iterate(allContent.spaces);
    return collectionNameMap;
}
